import * as Sentry from '@sentry/browser'
import { Service } from '@/services/helpers/ServiceHelper'
import type { CallContact } from '@/services/types/Contact'

export function useCallContacts () {
  const { userInfo } = storeToRefs(useUserStore())
  const { phoneMenus } = storeToRefs(useUserMenusStore())
  const snackbar = useSnackbar()

  const getCallContact = async (phoneFrom: string): Promise<CallContact | null> => {
    let contact: CallContact | null = { phone: phoneFrom, name: 'Unknown' }
    try {
      const primaryPhone = phoneMenus.value.find(
        (phone: { phone_number: string; is_seat: boolean }) => phone.is_seat
      )
      if (primaryPhone) {
        const contactResult = await Service?.gql?.contactGql?.findContactByPhone(
          primaryPhone.id,
          phoneFrom
        )
        if (contactResult) {
          contact = { phone: contactResult.phone!, name: contactResult.name! }
        }
      }
      return contact
    } catch (error) {
      Sentry.captureException(error)
      snackbar.error('Failed to get call contact')
      return contact
    }
  }

  const parseConferenceParticipants = async (participants: Array<any>): Promise<ConferenceParticipant[]> => {
    const loginId = userInfo.value?.id
    const realParticipants = participants.filter(p => p.login_id !== loginId)
    return await Promise.all(
      realParticipants.map(async p => ({
        callSid: p.call_sid,
        isOnHold: p.status === 'swapped',
        declined: p.status === 'completed',
        accepted: p.status === 'in-progress',
        contact: await getCallContact(p.participant_number)
      }))
    )
  }

  return { getCallContact, parseConferenceParticipants }
}
